import { createAction, props } from '@ngrx/store';
import { ItemConfigurationHeaderViewModel } from 'src/app/models/config-view-models';
import { ItemConfigurationViewModel, ProductType } from 'src/app/models/dbmodels';

//cns: all code strings in same object
// export const loadAllItemCodeStringValues = createAction(
//   '[ItemCodeString] Load All Item Code Strings'
// );

export const updateItemConfiguration = createAction(
  '[ItemConfiguration] Update Item Configuration',
  props<{ itemConfig: ItemConfigurationViewModel }>()
)

export const updateItemConfigurationHeader = createAction(
  '[ItemConfiguration] Update Item Configuration Header',
  props<{ itemConfigHeader: ItemConfigurationHeaderViewModel }>()
)
export const clearItemConfigurationHeader = createAction(
  '[ItemConfiguration] Clear Item Configuration Header',
)
export const updateLineItemId = createAction(
  '[ItemConfiguration] Update Schedule Line Item Id',
  props<{ lineItemId: number }>()
)
export const loadPerformanceLineItem = createAction(
  '[ItemConfiguration] Load Performance Line Item By Schedule Line Item Id',
);
export const clearPerformanceLineItem = createAction(
  '[ItemConfiguration] Clear Performance Line Item',
);
export const loadPerformanceLineItemSuccess = createAction(
  '[ItemConfiguration] Search Pricing Success',
  props<{ projectScheduleLineItem }>()
);
export const loadPerformanceLineItemFailure = createAction(
  '[ItemConfiguration] Load Pricing Line Item Failure',
  props<{ error: Error }>()
);

export const loadPricingLineItem = createAction(
  '[ItemConfiguration] Load Pricing Line Item By Schedule Line Item Id',
);
export const loadPricingLineItemSuccess = createAction(
  '[ItemConfiguration] Search Pricing Success',
  props<{ projectScheduleLineItemPricing }>()
);
export const loadPricingLineItemFailure = createAction(
  '[ItemConfiguration] Load Pricing Line Item Failure',
  props<{ error: Error }>()
);

